import { render } from "./EntryProduct.vue?vue&type=template&id=06f6b298"
import script from "./EntryProduct.vue?vue&type=script&lang=js"
export * from "./EntryProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__